import script from "./Connect.vue?vue&type=script&setup=true&lang=js"
export * from "./Connect.vue?vue&type=script&setup=true&lang=js"

import "./Connect.vue?vue&type=style&index=0&id=25cce7ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cce7ba"]])

export default __exports__